

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

require('xo-address-components/src/address-display/directive');

var _index = require('xo-models/src/checkout/index');

require('xo-page-components/src/aside-header/directive');

require('xo-tray-height/dist/directive');

require('xo-ui-components/src/accessibility/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoDeleteShipping', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            sidebar: '=?'
        },
        controller: ['$scope', function ($scope) {
            var contingencyMapping = {
                RISK_CHECK_FAILED: 'deleteShipping.genericError',
                ADDRESS_ALREADY_REMOVED: 'deleteShipping.genericError',
                ADDRESS_CANNOT_REMOVE_PRIMARY: 'deleteShipping.primaryOrBillingAddress',
                ADDRESS_CANNOT_REMOVE_BILLING: 'deleteShipping.primaryOrBillingAddress',
                ADDRESS_CANNOT_REMOVE_SELECTED: 'deleteShipping.selectedAddress',
                ACCOUNT_NEGATIVE_BALANCE: 'deleteShipping.genericError',
                ADDRESS_CANNOT_REMOVE: 'deleteShipping.genericError'
            };

            function isPrimaryOrSelected(address) {
                return address.primary_address || address.default_address;
            }

            function removeAddress(address) {
                $('#deleteShipping .address' + address.idx).addClass('collapse');
                (0, _angular.$timeout)(function () {
                    $scope.checkoutShippingAddresses.addresses = $scope.checkoutShippingAddresses.addresses.filter(function (item) {
                        return item.id !== address.id;
                    });
                    $scope.$broadcast('addressUpdated');
                }, 600);
            }

            (0, _squid.$populate)($scope, {
                checkoutShippingAddresses: _index.$CheckoutShippingAddressesModel.instance($scope.token)
            }).then(function () {
                $scope.checkoutShippingAddresses.addresses.forEach(function (address, index) {
                    address.showDelete = address.isDeletable = !isPrimaryOrSelected(address);
                    address.idx = index;
                });
                $scope.$broadcast('addressUpdated');
            });

            $scope.backUrl = 'checkout.review.sidebar.shipping';

            // Return on modal cancel
            $scope.goBack = function () {
                _uiRouter.$state.go($scope.backUrl);
            };

            // Needed the three variables for animating buttons slide in/out
            $scope.onDelete = function (address) {
                address.showConfirm = true;
                $scope.checkoutShippingAddresses.addresses.forEach(function (item) {
                    if (item.deleteClicked) {
                        $('#deleteShipping .address' + item.idx + ' .address').removeClass('slide');
                        $('#deleteShipping .address' + item.idx + ' .confirm').removeClass('slidein');
                        item.showDelete = true;
                        (0, _angular.$timeout)(function () {
                            item.deleteClicked = false;
                            item.showConfirm = false;
                            $('#deleteShipping .address' + item.idx + ' .delete:not(.confirm)').removeClass('slideOut');
                        }, 500);
                    }
                });

                address.deleteClicked = true;
                $('#deleteShipping .address' + address.idx + ' .delete:not(.confirm)').addClass('slideOut');
                (0, _angular.$timeout)(function () {
                    $('#deleteShipping .address' + address.idx + ' .confirm').addClass('slidein');
                    $('#deleteShipping .address' + address.idx + ' .address').addClass('slide');
                    address.showDelete = false;
                });
                // Focus the confirm link when it comes into view after the css animation
                (0, _angular.$timeout)(function () {
                    $('#deleteShipping .address' + address.idx + ' .confirmBtn').focus();
                }, 500);
            };

            $scope.showDelete = function (address) {
                return address.isDeletable && address.showDelete;
            };

            $scope.showConfirmDelete = function (address) {
                return address.isDeletable && address.showConfirm;
            };

            $scope.showInfoMsgIcon = function (address) {
                return isPrimaryOrSelected(address);
            };

            $scope.toggleInfoMessage = function (address) {
                if (address.default_address) {
                    address.contingencyInfoMsgKey = contingencyMapping.ADDRESS_CANNOT_REMOVE_SELECTED;
                } else if (address.primary_address) {
                    address.contingencyInfoMsgKey = contingencyMapping.ADDRESS_CANNOT_REMOVE_PRIMARY;
                }
                // Toggle the info message
                (0, _angular.$timeout)(function () {
                    var msg = angular.element('#deleteShipping .address' + address.idx + ' .msg-inline');
                    // eslint-disable-next-line no-unused-expressions

                    if (msg.hasClass('expand')) {
                        msg.removeClass('expand');
                        address.contingencyInfoMsgKey = '';
                    } else {
                        msg.addClass('expand');
                    }
                });
            };

            $scope.onConfirmDelete = function (address) {
                return address.action('delete', {
                    success: function success() {
                        return removeAddress(address);
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name) {
                            if (name === 'ADDRESS_ALREADY_REMOVED') {
                                removeAddress(address);
                                return;
                            }

                            address.isDeletable = false;
                            address.contingencyErrorMsgKey = contingencyMapping[name] || contingencyMapping.ADDRESS_CANNOT_REMOVE;
                            $('#deleteShipping .address' + address.idx + ' .address').removeClass('slide');
                            $('#deleteShipping .address' + address.idx + ' .address').addClass('slideFast');
                            (0, _angular.$timeout)(function () {
                                $('#deleteShipping .address' + address.idx + ' .msg-inline').addClass('expand');
                            }, 500);
                        }
                    }
                });
            };

            // Provide watch value for modal-box and select-box to recalculate keyboard behavior based on number of infoMsgIcons and confirmLinks
            $scope.numModalElements = function () {
                if (!$scope.checkoutShippingAddresses.addresses) {
                    return 0;
                }
                // Track messages by index, if they have flags active, seeing which flags they have active
                return $scope.checkoutShippingAddresses.addresses.reduce(function (sum, address, index) {
                    var item = $scope.showInfoMsgIcon(address) || $scope.showConfirmDelete(address) ? index + 1 : 0;

                    return sum + item;
                }, 0);
            };
        }]
    };
});

_angular.$timeout;

_squid.$populate;

_uiRouter.$state;

_index.$CheckoutShippingAddressesModel;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-member-components/src/select-shipping/delete-shipping/directive.js
// module id = ../node_modules/xo-member-components/src/select-shipping/delete-shipping/directive.js
// module chunks = 0